export const COURSE_PREVIEW_PAGE = 'coursePreview';
export const REGISTRATION_PAYMENT = 'registrationPayment';
